import { TranslateService } from '@ngx-translate/core';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { ModelOptionsLoaderService } from '../../services/model-options-loader/model-options-loader.service';
import { assignModelOptions } from '../../utilities/assign-model-options';
import { CompositeModel } from '../complex/composite.model';
import { MultilineTextModel, ODataTextLineOutModel } from '../primitive/multiline-text.model';

const odataCommentsForCustomerSet = 'CommentsForCustomerSet';

export class ConfirmationCommentsForCustomerModel extends CompositeModel {
    public commentsForCustomerText: MultilineTextModel;
    public constructor() {
        super('ConfirmationCommentsForCustomerModel');

        // Dependency injection
        const injector = CustomInjector.getInjector();
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);
        const translate = injector.get(TranslateService);

        this.commentsForCustomerText = <MultilineTextModel>(
            this.set(new MultilineTextModel(odataCommentsForCustomerSet))
        );

        modelOptionsLoader.load(this.commentsForCustomerText, 'CommentsForCustomer', 'CommentsField');
        this.commentsForCustomerText = assignModelOptions(
            this.commentsForCustomerText,
            {
                ...this.commentsForCustomerText.options,
                placeholder: <string>translate.instant('CONFIRMATION_COMMENTS_FOR_CUSTOMER_PLACEHOLDER', {
                    length: this.commentsForCustomerText.options.maxLength,
                }),
            },
            this,
        );

        const rowAmount = 6;
        this.commentsForCustomerText = assignModelOptions(
            this.commentsForCustomerText,
            {
                ...this.commentsForCustomerText.options,
                rows: rowAmount,
            },
            this,
        );
    }

    public toJSON(): unknown {
        return {
            commentsForCustomerText: this.commentsForCustomerText.value,
        };
    }
}

export class ConfirmationCommentsForCustomerModelFromJson extends ConfirmationCommentsForCustomerModel {
    public constructor(data: JsonConfirmationCommentsForCustomerModel) {
        super();
        this.commentsForCustomerText.value = data.commentsForCustomerText;
    }
}

export interface JsonConfirmationCommentsForCustomerModel {
    commentsForCustomerText: string;
}

export interface ODataConfirmationCommentsForCustomerOutModel extends ODataObject {
    CommentsForCustomerSet: ODataTextLineOutModel[];
}
